
import openable from '@/mixins/openable'
import { mapGetters } from 'vuex'

export default {
    mixins: [openable],
    props: {
        test: Boolean,
        round: Boolean,
        xs: Boolean,
        sm: Boolean,
        xl: Boolean,
        block: Boolean,
        icon: Boolean,
        top: Boolean,
        hideHeader: Boolean,
        forceDropdown: Boolean,
        disabled: Boolean,
        hiddenButton: Boolean,
        contentClass: {
            type: String,
            default: 'gap-4 py-4',
        },
        buttonClass: {
            type: String,
            default: undefined,
        },
        buttonStyle: {
            type: Object,
            default: () => {},
        },
        caret: {
            type: Boolean,
            default: true,
        },
        variant: {
            type: String,
            default: 'general-transparent',
        },
        placement: {
            type: String,
            default: 'bottom-end',
        },
    },
    data() {
        return {
            dropdown: undefined,
            backdropOpen: false,
        }
    },
    computed: {
        ...mapGetters({
            smDevice: 'data/smDevice',
        }),
        slideTop() {
            return this.$store.getters['data/smDevice'] && !this.forceDropdown
        },

        classes() {
            return this.slideTop
                ? `fixed bottom-0 left-0 w-full rounded-t-3xl`
                : `absolute rounded-lg right-0  ${this.top ? 'bottom-full mb-2' : 'top-full mt-2 '}`
        },
        dropdownMode(){

            return !this.smDevice || this.forceDropdown
        },
    },
    watch: {
        smDevice(value) {
            if (value && !this.forceDropdown && this.dropdown?.destroy) {
                this.dropdown.destroy()
                this.dropdown = null
            } else if (!value) {
                this.definePopper()
            }
        },
        isOpen(value) {
            if(value && this.dropdown?.update) this.$nextTick(()=> {this.dropdown?.update()

                this.addListeners()
            })
            if(!this.dropdownMode)
                if (value) {
                    document.querySelector('body').classList.add('modal-open')
                    setTimeout(()=>{
                        this.backdropOpen = true
                    }, 150)
                } else {
                    document.querySelector('body').classList.remove('modal-open')
                    this.backdropOpen = false
                }
        }

    },
    mounted() {
        if (this.dropdownMode && process.browser) this.definePopper()
    },
    methods: {
        definePopper() {
            if (!process.browser) return
            this.$nextTick(() => {
                let button = this.$refs.button
                const dropdown = this.$refs.dropdown
                if (!button && this.$attrs['aria-ref']) {
                    button = document.querySelector(`[for="${this.$attrs['aria-ref']}"]`)
                }
                if (button && dropdown) {
                    this.dropdown = this.$createPopper(button, dropdown, {
                        placement: this.placement,
                    })
                    this.dropdown?.update()
                }
                if (this.test) console.log(this.dropdown)
            })
        },
        addListeners() {
            window.addEventListener('resize', this.autoClose)
            window.addEventListener('scroll', this.autoClose)
        },
        removeListeners() {
            window.removeEventListener('resize', this.autoClose)
            window.removeEventListener('scroll', this.autoClose)
        },
        close() {
            if (!this.disabled) {
                this.isOpen = false
                this.$emit('close')
                this.removeListeners()
            }
        },
        toggle() {
            if (!this.disabled) {
                this.isOpen = !this.isOpen
                this.$emit(this.isOpen ? 'open' : 'close')
                this.removeListeners()
            }
        },
        autoClose() {
            if (!this.disabled && this.isOpen) {
                console.log('autoclose')
                this.isOpen = false
                this.$emit('auto-close')
                this.removeListeners()
            }
        },
        clickOutsideManual(e) {
            if (!this.auto && !this.disabled && (e.target?.attributes?.for?.value !== this.$attrs['aria-ref'] || !this.$attrs['aria-ref'])) {
                this.autoClose()
            }
        },
    },
}
